import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCompleteTask = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while completing task");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (taskId) => {
      const axiosInstance = await createAxiosInstance();
      await axiosInstance.post(`${tenantVal}/task/close/${taskId}`, {
        id: taskId,
        tenant: tenantVal,
      });
    },
    onSuccess: () => {
      toast.success("Task completed successfully");
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      queryClient.invalidateQueries({ queryKey: ["homeTasks"] });
      queryClient.invalidateQueries({ queryKey: ["closedPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["paginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["sentPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["prescriptionTasks"] });
      queryClient.invalidateQueries({ queryKey: ["patientTasks"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};
